<template>
<div>	
<template v-if="progress===false">
<div class="flex justify-content-start   flex-wrap">
<ProgressSpinner style="width: 18px; height: 18px;margin-top: 0em;margin-left: 0;margin-right: 1em;" strokeWidth="3" fill="var(--surface-ground)"
    animationDuration=".5s" aria-label="Custom ProgressSpinner" />
<p class="text-blue-500 my-0">{{$store.state.languages.lang_phrases.sirada}}</p>
</div>
</template>

<template v-else-if="progress===true">
<p class=" m-0"><span class="material-symbols-outlined  text-green-500 md-24 ">check_circle</span></p>
</template>

<template v-else>
<ProgressBar :value="progress" 
:showValue="false" 
class="mt-3"
v-tooltip.top="{ value: progress+'%', escape: true }"></ProgressBar>	
</template>




</div>
</template>

<script>
export default {
  props:["data"],
  name: '"ReportProgersssBar"',

  data () {
    return {
    	progress:false,
    }
  },
  sockets: {
  	update_report_progress(data) {  

      if(data.report_id==this.data.id)
      {
      	
      	if(data.percentage=="started")
      	{
      		this.progress = false
      	}
      	else if(data.percentage=="finished")
      	{
      		this.progress = true
      	}
      	else
      	{
      		this.progress = parseInt(data.percentage)
      	}
      	
      }
    },
  },
  mounted()
  {
  	
  	let is_uptodate
  	if(this.data.is_uptodate===1) 
  	{
  		is_uptodate = true
  	}
  	if(this.data.is_uptodate===0) 
  	{
  		is_uptodate = false
  	}
  	this.progress = is_uptodate
  },
  computed:{

  }
}
</script>

<style lang="css" scoped>
.p-progressbar{
	height: .6rem;
}
</style>